<template>
    <div class="sustainable-component admin-example-companies" style="position:relative;">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-company-all</div>-->
        <div class="container-fluid p-0 mt-3">
            
            <div class="row table-space p-3">
                <b>Visar {{companies.length}} företag</b>

                <div class="mt-3">
                    <v-text-field @change="loadCompanies" bg-color="white"
                                  name="FilterCompanyName"
                                  id="FilterCompanyName"
                                  type="text"
                                  label="Filtrera på företagsnamn, email eller avdelningsnamn"
                                  variant="outlined"
                                  v-model="filter"
                                  focused="true"></v-text-field>
                </div>

                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            
                            <th class="col-2">Namn</th>
                            <th class="col-2">Kategori</th>
                            <th class="col-2">Roll</th>
                            <th class="col-2">Avdelning</th>
                            <th class="col-2">Skapad av</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in companies" :key="index">
                            <td>{{item.Name}} ({{item.CompanyId}})</td>
                            <td>{{item.Category}}</td>
                            <td>{{item.Role}}</td>
                            <td>{{item.DepartmentName}}</td>
                            <td v-html="item.UserName"></td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateExampleCompany(item)">Uppdatera</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="removeExampleCompany(item)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateExampleCompany ref="updateExampleCompanyModal" @updated="onExampleCompanyUpdated"></UpdateExampleCompany>
    </div>
</template>


<script>
    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import UpdateExampleCompany from './update/update-example-company.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateExampleCompanyModal = ref(null);

    export default {

        name: 'admin-example-companies',
        props: {

        },
        components: {
            CommonSpinner,
            UpdateExampleCompany
        },
        methods: {

            async removeExampleCompany(company) {
                this.loading++;
                var idToRemove = company.Id;
                try {
                    await AdminService.removeExampleCompany(idToRemove);
                    this.displaySnackBar("Bolaget är borttaget från exempel");
                    this.loadCompanies();
                    if(window.refreshCompanies) {
                       window.refreshCompanies();
                    }
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async updateExampleCompany(company) {
                this.updateExampleCompanyModal.open(company);
            },
            async loadCompanies() {
                this.loading++;
                try {
                    this.companies = await AdminService.getExampleCompanies(this.filter);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
            async onExampleCompanyUpdated() {
                this.displaySnackBar("Exempelbolaget uppdaterades");
                await this.loadCompanies();
                if (window.refreshCompanies) {
                    window.refreshCompanies();
                }
            }
        },

        data() {
            return {
                filter: null,
                rules: ValidationService.rules(),
                companyloaded: false,
                companies: [],
                loading: 0,
                showSnackBar:false,
                snackbarMessage:null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
        },
        mounted() {
            this.loadCompanies();
           
        },
        setup() {
            return { form, updateExampleCompanyModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
